// typings
import {
  LibrarySymbolInfo,
  SubscribeBarsCallback,
} from '../../../../sources/charting_library.min';

// PAY ATTENTION!!!
// Moved from TradingView/utils/services/barsProvider/barsProvider.ts
// You can find this file in GIT history

abstract class AbstractBarsProviderLive {
  abstract subscribeToLiveBars(
    symbolInfo: LibrarySymbolInfo,
    resolution: string,
    newDataCallback: SubscribeBarsCallback,
    ticker: string,
    listenerGuid: string,
    onResetCacheNeededCallback: () => void,
  ): void;

  abstract unsubscribeFromLiveBars(
    guid: string,
    onNewDataListenerGuid: string,
  ): void;
}

export default AbstractBarsProviderLive;
